import { Chip, ChipProps } from "@mui/material";
import React from "react";
import { ColorType } from "../../../../Core/Api/Types/color-type";

export interface UserChipProps extends ChipProps {
  colorType?: string | null;
  roleName?: string | null;
}

const UserChip: React.FC<UserChipProps> = (props) => {
  const { colorType, roleName, ...otherProps } = props;

  let _color: ChipProps["color"] = "primary";
  switch (colorType) {
    case ColorType.Green:
      _color = "success";
      break;
    case ColorType.Yellow:
      _color = "info";
      break;
    case ColorType.Orange:
      _color = "warning";
      break;
    case ColorType.Red:
      _color = "error";
      break;
    case ColorType.Grey:
      _color = "default";
      break;
    case ColorType.Blue:
      _color = "primary";
      break;
    default:
      _color = "default";
      break;
  }

  return <Chip color={_color} size="small" {...otherProps} label={roleName || "No role"} />;
};

export default UserChip;
